import { render, staticRenderFns } from "./VersionPatch.vue?vue&type=template&id=97e8a21a&"
import script from "./VersionPatch.vue?vue&type=script&lang=js&"
export * from "./VersionPatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports